import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AuthGuardService } from 'src/app/shared/services/auth.service';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';


const routes: Routes = [
    {
        path: ConstantsRotasDoSistema.DASHBOARD,
        component: DashboardComponent,
        canActivate: [AuthGuardService]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
